var map = {
	"./diapositiva-10-1.jpg": "4480",
	"./diapositiva-10-2.jpg": "09d0",
	"./diapositiva-10-3.jpg": "269d",
	"./diapositiva-10-4.jpg": "db56",
	"./diapositiva-10-5.jpg": "5073"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d462";